export default __webpack_public_path__ + "static/media/laptop.e2e3e55d.png";